import React from "react";
import "./StatusTag.scss"; // Import SCSS

const StatusTag = ({ status }: { status: string }) => {
  return <span className={`status-tag ${status.toLowerCase()}`}>{status}</span>;
};

export default StatusTag;
